export const onCellEditingStoppedEvent = ({ params, onCellEditingStopped }) => {
  if (onCellEditingStopped) onCellEditingStopped(params);
};